import Vue from "vue";
import $ from "jquery";
import Toasted from 'vue-toasted';
import VueDialog from 'vuejs-dialog';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import DibbleApi from './api';
import DibbleTranslation from "./translation/translation";


Vue.use(require('vue-cookies'));
Vue.use(Toasted);
Vue.use(VueDialog);

const DibbleJS = {
    config: {},
    state: {
        apiStack: []
    },
    AnchorNoHandlerHref: 'javascript:void(0)',
    initDefaultDropdownChoice(element, default_value = '') {
        const value = {
            text: DibbleTranslation.trans('global.label.select_default'),
            value: default_value
        };

        element.push(value);
        return element;
    },
    cookieDestroy() {
        Vue.$cookies.remove('_user');
        Vue.$cookies.remove('_token');
    },
    getDefaultDropDownChoice(default_value = ''){
        return {
            text: DibbleTranslation.trans('global.label.select_default'),
            value: default_value
        };
    },
    toggleActions(id, moduleStr) {
        DibbleJS.collapseAllOtherActions(id, moduleStr);
        const btn = $('#' + moduleStr + '-action-' + id);
        if ($(btn).is(":visible")) {
            $(btn).removeClass('d-flex').hide();
            $(btn).next('.collapse').show();
        } else {
            $(btn).addClass('d-flex').show();
            $(btn).next('.collapse').hide();
        }
    },
    collapseAllOtherActions(exceptId = '', moduleStr) {
        $('.' + moduleStr + '-action-btn').each(function () {
            if (exceptId !== '' && exceptId === $(this).data(moduleStr + '-id')) {
                DibbleJS.logEventConsole("Ignored " + exceptId);
            } else {
                $(this).addClass('d-flex');
                $(this).next('.collapse').hide();
            }
        })
    },
    showLoader() {
        $('.global-loading').show();
    },
    hideLoader() {
        $('.global-loading').hide();
    },
    confirmBox(message, callBack) {
        const options = {
            html: true, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
            loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
            reverse: false, // switch the button positions (left to right, and vise versa)
            okText: DibbleTranslation.trans('pinker.confirm'),
            cancelText: DibbleTranslation.trans('pinker.cancel'),
            animation: 'zoom', // Available: "zoom", "bounce", "fade"
            type: 'basic', // coming soon: 'soft', 'hard'
            verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
            backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
            customClass: '' // Custom class to be injected into the parent node for the current dialog instance
        };

        Vue.dialog
            .confirm(message, options)
            .then(function() {
                callBack();
            })
    },
    toastErrorMessage(message) {
        const options = {
            type : 'error',
            theme: 'bubble',
            duration: 5000,
            position: 'bottom-center'
        };
        Vue.toasted.show(message, options);
    },
    toastSuccessMessage(message) {
        const options = {
            type : 'success',
            theme: 'bubble',
            duration: 5000,
            position: 'bottom-center'
        };
        Vue.toasted.show(message, options);
    },
    checkIsExpiredSession() {
        if (!Vue.$cookies.get('_token')) {
            window.location.href='/login';
        }
    },
    callAnomyousRequest(data, successCallback, preventOverlapCall = false) {
        if (preventOverlapCall) {
            const isProcessing = DibbleJS.state.apiStack.find(apiName => apiName === data.request);
            if (typeof isProcessing !== 'undefined') {
                DibbleJS.logEventConsole('Duplicate called event name ', data.request);
                return false;
            }
        }
        DibbleJS.state.apiStack.push(data.request);
        console.log(DibbleApi.endpoint)
        console.log(JSON.stringify(data))
        $.ajax({
            url: DibbleApi.endpoint,
            type: 'POST',
            data: JSON.stringify(data),
            dataType: 'json',
            success: function (responseData) {
                console.log(JSON.stringify(responseData))                
                DibbleJS.apiSuccessCallBack(data, responseData, successCallback)
                DibbleJS._removeApiStack(data.request);
            },
            error: function (xhr, textStatus, errorThrown) {
                DibbleJS._removeApiStack(data.request);
                console.log('error');
                console.log(JSON.stringify(xhr));
                console.log(textStatus);
                console.log(errorThrown);
                DibbleJS.hideLoader();
                DibbleJS.toastErrorMessage(DibbleTranslation.trans('global.error.api.error'))
            }
        });
    },
    callApiRequest(data, successCallback, preventOverlapCall = false) {
        if (window.location.href.indexOf('login') < 0) {
            const token = Vue.$cookies.get('_token');
            if (!token) {
                window.location.href='/login';
            }
            data['#token'] = token;
        }

        if (preventOverlapCall) {
            const isProcessing = DibbleJS.state.apiStack.find(apiName => apiName === data.request);
            if (typeof isProcessing !== 'undefined') {
                DibbleJS.logEventConsole('Duplicate called event name ', data.request);
                return false;
            }
        }
        DibbleJS.state.apiStack.push(data.request);
        console.log(DibbleApi.endpoint)
        console.log(JSON.stringify(data))
        $.ajax({
            url: DibbleApi.endpoint,
            type: 'POST',
            data: JSON.stringify(data),
            dataType: 'json',
            success: function (responseData) {
                console.log(JSON.stringify(responseData))
                if (parseInt(responseData.rc) === 201) {
                    window.location.href='/login';
                } else {
                    DibbleJS.apiSuccessCallBack(data, responseData, successCallback)
                }
                DibbleJS._removeApiStack(data.request);
            },
            error: function (xhr, textStatus, errorThrown) {
                DibbleJS._removeApiStack(data.request);
                console.log('error');
                console.log(JSON.stringify(xhr));
                console.log(textStatus);
                console.log(errorThrown);
                DibbleJS.hideLoader();
                DibbleJS.toastErrorMessage(DibbleTranslation.trans('global.error.api.error'))
            }
        });
    },
    callGetRequest(url, successCallback) {
        $.ajax({
            url: url,
            type: 'GET',
            data: '',
            success: successCallback,
            error: function (xhr, textStatus, errorThrown) {
                DibbleJS.logEventConsole('error');
                DibbleJS.logEventConsole(errorThrown);
            }
        });
    },
    apiSuccessCallBack(data, responseData, successCallback) {
        console.log('request => ', data);
        console.log('response => ', responseData);
        successCallback(responseData);
    },
    isResponseObjectHasData(objects) {
        return typeof objects.length === 'undefined';
    },
    logEventConsole(thing) {
        if (process.env.NODE_ENV === 'development') {
            console.log(thing);
        }
    },
    _removeApiStack(apiName) {
        if (DibbleJS.state.apiStack.length === 1) {
            DibbleJS.state.apiStack = [];
        } else {
            DibbleJS.state.apiStack = DibbleJS.state.apiStack.filter(item => item !== apiName);
        }
    }
}

export default DibbleJS;
